export const apiGateWayWebSocketUrl: string = 'wss://6puia97db8.execute-api.eu-west-1.amazonaws.com/dev/';